function openMiniCart() {
  const cartDrawer = document.getElementsByTagName('cart-drawer');

  cartDrawer[0].classList.add('is-visible');
  refreshCartDrawer();
}

function refreshCartDrawer() {
  fetch("/cart?view=drawer")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartContents = doc.getElementById("CartDrawer-Body").innerHTML;
      document.getElementById("CartDrawer-Body").innerHTML = cartContents;

      // Get the CartDrawer class to access static debounce
      const CartDrawer = customElements.get('cart-drawer');
      if (CartDrawer) {
        // Use the same debounce mechanism as renderContents
        clearTimeout(CartDrawer.cartUpdateTimeout);
        CartDrawer.cartUpdateTimeout = setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, CartDrawer.CART_UPDATE_DEBOUNCE || 300);
      } else {
        // Fallback if CartDrawer class not found
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, 300);
      }

      fetch('/cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
      }).then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(data => {
        let updatedQuantity = data.item_count ?? 0;
        document.getElementsByClassName('cart-count-badge')[0].classList.remove('hidden');
        document.getElementsByClassName('cart-count-badge')[0].textContent = updatedQuantity;
      });
    })
    .catch((error) => console.error("Erro ao carregar o minicart:", error));
}